import { render, staticRenderFns } from "./FakePageActions.vue?vue&type=template&id=c7168410&"
import script from "./FakePageActions.vue?vue&type=script&lang=ts&"
export * from "./FakePageActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports